{
    "coordinates": [
        -8.568127638834753,
        120.48974418122503
    ],
    "tooltip": "Flores",
    "title": "Pleistocene Flores",
    "country": "Indonesia",
    "period": "Quaternary",
    "alt": "TODO"
}
